import { TypedContainer } from "./_Base";
export class EventContainer extends TypedContainer {
  set_content(content) {
    super.set_content(content);
  }
}
